import {RequestAxios} from "../../index";
import {TrainerById} from "./interfaces";
import {API_START} from "../../constants";

export const getTrainerById = async (id: number) => {
    const trainersIdUrl = `${API_START}/personnel_management/client/personnel/${id}`;
    return await RequestAxios.get<TrainerById>(trainersIdUrl)
}